import { action, observable } from 'mobx';
import { QuestionModel } from '@/survey/logic/QuestionModel';
import type { Answer } from '../../../types';

export class MultiSelectModel extends QuestionModel {
  @observable accessor responseLimitsReached: boolean = false;

  @action
  set_responseLimitsReached(responseLimitsReached: boolean) {
    this.responseLimitsReached = responseLimitsReached;
  }

  @action
  handleClickOption = (answerId: number) => {
    if (this.selectedAnswers.some((a) => a.id === answerId)) {
      this.set_selectedAnswers(this.selectedAnswers.filter((a) => a.id !== answerId));
      this.set_responseLimitsReached(false);
    } else {
      const answerToSelect = this.question.form_answers.find((a) => a.id === answerId);
      if (!answerToSelect) {
        return;
      }

      this.set_selectedAnswers([...this.selectedAnswers, answerToSelect]);

      if (this.question.response_limits && this.question.response_limits < this.selectedAnswers.length + 1) {
        this.set_responseLimitsReached(true);
        return;
      }
    }
  };

  isAnswerSelected(answer: Answer): boolean {
    return this.selectedAnswers.some((a) => a === answer);
  }

  isAnswerDisabled(answer: Answer): boolean {
    return this.disabled || (this.responseLimitsReached && !this.isAnswerSelected(answer));
  }
}
